import { set } from 'nprogress';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    Intercom: (event: string, options?: { [key: string]: any }) => void;
  }
}

const Intercom: FC = () => {
  const therapistData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );

  const [initiated, setInitiated] = useState(false);

  useEffect(() => {
    if (therapistData?.firstName) {
      if (!initiated) {
        window.Intercom('boot', {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'vz5ddvwr',
          name: therapistData?.firstName + ' ' + therapistData?.lastName,
          user_id: therapistData?.providerId,
          email: therapistData?.email,
        });
      }

      setInitiated(true);
    }
  }, [therapistData, initiated]);

  const location = useLocation();

  useEffect(() => {
    window.Intercom('update');
  }, [location.pathname]);

  return <></>;
};

export default Intercom;
